import * as Sentry from "@sentry/react"
import { IS_DEV } from "../consts/index"

export function initSentry() {
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: process.env.GATSBY_ENV_NAME,
    enabled: !IS_DEV,
    tracesSampleRate: 1.0,
    ignoreErrors: [/Minified React error/],
  })
}
